import type { QuoteRequestStatus } from '@repo/api-contracts';

/**
 * 상태 배지의 결 — 고객이 지금 무엇을 해야 하는지로 나눈다.
 * - action: 고객 응답이 필요하다(유일한 라임 강조).
 * - progress: 운영자가 처리 중이다.
 * - ordered: 주문으로 넘어갔다.
 * - closed: 더 진행되지 않는다(거절·반려·취소·만료).
 */
export type QuoteStatusTone = 'action' | 'progress' | 'ordered' | 'closed';

export const QUOTE_STATUS_TONES: Readonly<Record<QuoteRequestStatus, QuoteStatusTone>> = {
  REQUESTED: 'progress',
  ISSUED: 'action',
  REVISION_REQUESTED: 'progress',
  ORDERED: 'ordered',
  DECLINED: 'closed',
  REJECTED: 'closed',
  CANCELED: 'closed',
  EXPIRED: 'closed',
};
